import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { useNavigate } from "react-router-dom";
import type { AppDispatch } from "../core/data/redux/store";
import { useDispatch } from "react-redux";
import { setMobileSidebar } from "../core/data/redux/commonSlice";
import { all_routes } from "../router/backendComponents/website/all_routes";

type RouteOption = {
  value: string;
  label: string;
};

const RouteSearch: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [selectedOption, setSelectedOption] = useState<RouteOption | null>(null);

  const flattenRoutes = (obj: any, prefix = ""): RouteOption[] =>
    Object.entries(obj).flatMap(([key, val]) => {
      if (key === "backend") return [];
      if (typeof val === "string") {
        return [{ value: val, label: `${key} (${val})` }];
      }
      if (typeof val === "object" && val !== null) {
        return flattenRoutes(val, `${prefix}${key}.`);
      }
      return [];
    });

  const allFrontendRoutes = flattenRoutes(all_routes);

  const loadOptions = (inputValue: string): Promise<RouteOption[]> => {
    return new Promise((resolve) => {
      if (!inputValue.trim()) {
        resolve([]); // nothing until user types
        return;
      }
      const filtered = allFrontendRoutes.filter((route) =>
        route.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      resolve(filtered);
    });
  };

  const handleSelect = (selected: RouteOption | null) => {
    if (selected) {
      if (window.innerWidth <= 1024) {
        dispatch(setMobileSidebar(false));
      }
      navigate(selected.value);
      setSelectedOption(null); // clear select after navigation
    }
  };

  return (
    <div className="icon-form mb-3">
      <AsyncSelect
        cacheOptions
        defaultOptions={false}
        loadOptions={loadOptions}
        value={selectedOption}
        onChange={(opt) => {
          setSelectedOption(opt);
          handleSelect(opt);
        }}
        isClearable
        placeholder={"Search Menu"}
      />
    </div>
  );
};

export default RouteSearch;
